
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';


const API_URL = (
  process.env.REACT_APP_BACKEND_URL || 'https://api.yashsoftsolution.com/api/v1'
).replace(/\/$/, '');


export const submitCareer = createAsyncThunk(
  'career/submitCareer',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/career`, formData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const careerSlice = createSlice({
  name: 'career',
  initialState: {
    loading: false,
    success: null,
    error: null,
  },
  reducers: {
    clearCareerState: (state) => {
      state.loading = false;
      state.success = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitCareer.pending, (state) => {
        state.loading = true;
        state.success = null;
        state.error = null;
      })
      .addCase(submitCareer.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload;
      })
      .addCase(submitCareer.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCareerState } = careerSlice.actions;
export default careerSlice.reducer;
